import React from 'react'

export default function ContactDB() {
  return (
    <div>ContactDB</div>
  )
}
